import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Service Center Functionalization Entry: The association(s) between service centers and functional usage.',
    name: 'Service Center Functionalization',
    partialId: PartialId.Standard.create('svc_center_funcl'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
